<template>
    <div id="status-filter">
        <div class="uk-text-medium uk-text-semibold uk-text-primary uk-margin-xsmall-bottom">Filtrer på status:</div>
        <label class="uk-display-block uk-margin-bottom uk-text-nowrap">
            <input type="checkbox" v-model="filter" value="Forberedes" class="uk-checkbox uk-margin-small-right" />
            <span uk-icon="preparing" class="uk-text-primary uk-margin-xsmall-right"></span>Forberedes</label>
        <label class="uk-display-block uk-margin-bottom uk-text-nowrap">
            <input type="checkbox" v-model="filter" value="Planlegges" class="uk-checkbox uk-margin-small-right " />
            <span uk-icon="planning" class="uk-text-primary uk-margin-xsmall-right"></span>Planlegges</label>
        <label class="uk-display-block uk-margin-bottom uk-text-nowrap">
            <input type="checkbox" v-model="filter" value="Bygger" class="uk-checkbox uk-margin-small-right" />
            <span uk-icon="building" class="uk-text-primary uk-margin-xsmall-right"></span>Bygges</label>
        <label class="uk-text-nowrap">
            <input type="checkbox" v-model="filter" value="Åpnet" class="uk-checkbox uk-margin-small-right" />
            <span uk-icon="completed" class="uk-text-primary uk-margin-xsmall-right"></span>Ferdig</label>
    </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'

const emit = defineEmits(['filter'])

const filter = ref([])

watch(filter, (value) => {
    emit('filter', value)
})
</script>
<style scoped>
.uk-margin-xsmall-right{
    margin-right: 5px!important;
}
#status-filter .uk-checkbox{
    width: 20px;
    height: 20px;
    margin-right: 12px!important;
}
#status-filter label{
    font-size: 1rem;
    margin-bottom: 12px!important;
}
@media(min-width: 680px){
    #status-filter label{
    font-size: 1.125rem;
    }
    #status-filter .uk-checkbox{
        width: 24px;
        height: 24px;
    }
}
</style>